module.exports = __webpack_public_path__ + "bg-banner-right.png?e0ef7eb6a56d043b091295e0f7dbfad1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg-banner-right.png
// module id = 217
// module chunks = 0